import { ReactNode } from "react";
import classNames from "classnames"
import styles from "./ListSorter.module.css"


type ListCardProps = {
  children: ReactNode;
  onClick?: () => void;
  selected?: boolean;
}

export default function ListCard({ children, onClick, selected }: ListCardProps) {
  const cardClasses = classNames(styles.card, {
    [styles.selected]: selected,
  })

  if (onClick) {
    return <button onClick={onClick} className={cardClasses}>{children}</button>
  }
  return (
    <div className={cardClasses}>{children}</div>
  )
}
